const { PORTAL_ROUTE } = require('src/constants/routes');

const fmt = (value, loading) => (loading ? '...' : value ?? 0);

export const wdacResultsTabs = (counts = {}, loading = false) => [
  {
    label: `Win32 Apps (${fmt(counts.win32AppsCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-results/win32-apps`,
  },
  {
    label: `Unmatched Files (${fmt(counts.unmatchedFilesCrossDevicesCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-results/unmatched-files`,
  },
  {
    label: `Packaged Apps (${fmt(counts.packedAppsCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-results/packaged-apps`,
  },
  {
    label: `Scripts Execution (${fmt(counts.scriptsCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-results/script-execution`,
  },
  {
    label: `Managed Installers (${fmt(counts.managedInstallersCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-results/managed-installers`,
  },
  {
    label: `SECURITY CATALOGS (${fmt(counts.catalogInventoriesCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-results/catalog-inventory`,
  },
];

export const wdacAppTabs = (appId, counts = {}, loading = false) => [
  {
    label: 'General',
    value: `${PORTAL_ROUTE}/wdac-apps/${appId}/general`,
  },
  {
    label: `Files (${fmt(counts.filesCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-apps/${appId}/files`,
  },
  {
    label: `File Set Imports (${fmt(counts.fileSetsCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-apps/${appId}/file-sets`,
  },
  {
    label: `WDAC Telemetry (${fmt(counts.wdacFilesCount, loading)})`,
    value: `${PORTAL_ROUTE}/wdac-apps/${appId}/telemetry`,
  },
];
